import Grid from '@mui/material/Grid';

import Button, { type ButtonContent } from '@/components/OldButton/OldButton';
import type {
  Contentful,
  FrontifyImageContent,
} from '@/contentful/contentful-exports';
import useDeviceWidth from '@/hooks/deviceWidth';
import { brandColors } from '@/styles/theme/values/brandColors';
import { getFrontifyBackgroundImageUrl } from '@/utils/frontify';
import useStyles from './HeroOneHalfImage.styles';

export interface HeroOneHalfImageContent extends Contentful {
  fields: {
    title: string;
    body: string;
    image: FrontifyImageContent[];
    ctaButton: ButtonContent;
    imageAlignment: 'left' | 'right';
    backgroundColorStyle: 'Blue Gradient' | 'Light Blue Gradient';
  };
}

interface Props {
  content: HeroOneHalfImageContent;
}

export default function HeroOneHalfImage({ content }: Props) {
  const {
    title,
    body,
    image,
    ctaButton,
    imageAlignment,
    backgroundColorStyle,
  } = content.fields;
  const imageUrl = image[0].preview_url;
  const { isMobile } = useDeviceWidth();
  const { classes } = useStyles();
  // biome-ignore lint/suspicious/noImplicitAnyLet: Automated migration to Biome
  let backgrColor;
  let textColor: string;
  switch (backgroundColorStyle) {
    case 'Light Blue Gradient':
      backgrColor = `linear-gradient(180deg, ${brandColors.offWhite} 0%, ${brandColors.chargeBlue} 100%)`;
      textColor = brandColors.black;
      break;
    default:
      backgrColor = isMobile
        ? `linear-gradient(180deg, ${brandColors.primaryMain} 0%, ${brandColors.mediumBlue} 100%)`
        : `linear-gradient(180deg, ${brandColors.mediumBlue} 0%, ${brandColors.primaryMain} 100%)`;
      textColor = brandColors.white;
  }

  return (
    <Grid
      container
      style={{
        background: backgrColor,
        color: textColor,
        flexDirection: imageAlignment === 'left' ? 'row' : 'row-reverse',
      }}
      className={classes.heroContainer}
    >
      <Grid
        className={classes.heroSection}
        style={{
          backgroundImage: getFrontifyBackgroundImageUrl(imageUrl, 1440),
        }}
        size={{
          lg: 6,
          xs: 12,
        }}
      />
      <Grid
        className={classes.heroTextContainer}
        size={{
          lg: 6,
          xs: 12,
        }}
      >
        {/** biome-ignore lint/complexity/useOptionalChain: Automated migration to Biome */}
        {title &&
          title.split('\n').map((txt, index) => (
            <h1
              // biome-ignore lint/style/useTemplate: Automated migration to Biome
              // biome-ignore lint/suspicious/noArrayIndexKey: Automated migration to Biome
              key={'herotitle_' + index}
              className={classes.heroTitle}
              style={{
                color: textColor,
              }}
            >
              {txt.length === 0 ? '\xA0' : txt}
            </h1>
          ))}

        {/** biome-ignore lint/complexity/useOptionalChain: Automated migration to Biome */}
        {body &&
          body.split('\n').map((txt, index) => (
            <p
              // biome-ignore lint/style/useTemplate: Automated migration to Biome
              // biome-ignore lint/suspicious/noArrayIndexKey: Automated migration to Biome
              key={'herobody_' + index}
              className={classes.heroBody}
              style={{
                color: textColor,
              }}
            >
              {txt.length === 0 ? '\xA0' : txt}
            </p>
          ))}
        {ctaButton && (
          <div className={classes.heroButtom}>
            <Button {...ctaButton?.fields} />
          </div>
        )}
      </Grid>
    </Grid>
  );
}
